module.exports = __webpack_public_path__ + "static/media/check-icon.92b87809.svg";